import types from "../types/types";
import { getUserById } from "../components/selector/getUserById";

export const getUser = (encodedUserId) => {

    const usersAPI = getUserById(encodedUserId);
    
    return (dispatch) => {
        usersAPI.then( (response) =>{
            console.log(response);
            dispatch(user(response));
        })
        .catch(err => {
            console.log("getUser error: " + err);
            return Promise.reject(err);
            // throw new Error("err");
            // throw err;
        });
    }    
    
}

export const loadToken = (tokenValue ) => {
    return (dispatch) => {
        dispatch(token(tokenValue));
    } 
}

export const token = ( tokenValue ) => ({
    type: types.user_token,
    token: tokenValue,
})


// export const refreshToken = async () => {  /// ---> see here
//     return async (dispatch, getState) => {
//         dispatch({ type: actions.REFRESH_TOKEN_REQUEST });
//         /// your other code
//     };
// }
  

export const user = (user) => ({
    type: types.user_credentials,
    user: user 
});

// export const removeAndRestartReduxValues = () => ({
//     type: types.restart_redux_on_logout,
// });


export default {
    getUser,
    // user,
    loadToken,
}